import './bottom.scss';

export default function Bottom() {

    return (
        <div className={'app-footer'}>
            כל הזכויות שמורות - יהודה לבנוני ©
        </div>
    );
}